import common from "../common";

export default class TextManager {
constructor()
    {
    	
    }

init()
    {
    	
    }

prototypeText(string, formatting, maxCharacterWidth)
	{
		var textProps = {fontFamily : 'Arial', fontSize: 35, fill : 0xffffff, align : 'center'};
        
        if(formatting)
        {
	        for(var i in formatting)
	        {
	        	textProps[i] = formatting[i];
	        }
    	}

    	if(maxCharacterWidth !== undefined)
    		string = this.restrictText(string, maxCharacterWidth);

    	var text = new PIXI.Text(string, textProps);
        text.x = -text.width/2;
        text.y = -text.height/2;
        return text;
    }
    
translate(string)
    {
        if(common.config.translations[string] && common.config.translations[string][common.country])
            return common.config.translations[string][common.country];
        return string;
    }


restrictText(string, characterWidth, softCharacterWidth)
    {
        if(softCharacterWidth)
        {
            var spspl = string.split(" ");
            for(var i in spspl)
            {
                if(spspl[i].length > softCharacterWidth)
                    softCharacterWidth = spspl[i].length;
            }
            characterWidth = Math.min(characterWidth, softCharacterWidth);
        }

        var spl = string.split("\n");

        for(var i = 0; i < spl.length; i++)
        {
            if(spl[i].length > characterWidth)
            {
                var spaces = spl[i].split(" ");
                var newString = "";
                var nextString = "";
                var s;

                for(var j = 0; j < spaces.length; j++)
                {
                    if(spaces[j].length > characterWidth)
                    {
                        var c = spaces[j];
                        spaces[j] = c.slice(0, characterWidth-1) + '-';
                        spaces.splice(j+1, 0, c.slice(characterWidth-1));
                    }
                }

                for(var j = 0; j < spaces.length; j++)
                {
                    var addedSpace = j > 0 ? " " : "";
                    s = newString + addedSpace + spaces[j];
                    if(s.length <= characterWidth && nextString == "")
                    {
                        newString = s;
                    }
                    else
                    {
                        if(nextString == "") addedSpace = "";
                        nextString = nextString + addedSpace + spaces[j]; 
                    }
                }
                spl[i] = newString;
                spl.splice(i+1, 0, nextString);
            }
        }

        return spl.join("\n");
    }

} //EOF